var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"title":_vm.title,"ok-title":_vm.okButtonTitle,"cancel-title":_vm.cancelButtonTitle,"id":_vm.modalId},on:{"ok":_vm.onConfirm}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }